import { SigninComponent } from './signin/signin.component';

export const CONTAINERS = [SigninComponent];

export * from './signin/signin.component';
